// extracted by mini-css-extract-plugin
export default {"email_code_data":"emailCodeData_email_code_data__eYm7y","loading":"emailCodeData_loading__Sv39r","label":"emailCodeData_label__2cXi4","field":"emailCodeData_field__TWNgZ"};